export default {"src":"/_next/static/media/nothing-found.52ddc0f9.svg","height":240,"width":261,"blurWidth":0,"blurHeight":0};